const CorporationFund = () => import('@/modules/corporationfund/CorporationFundlist')
const HNCorporationFund = () => import('@/modules/HNcorporationfund/HNCorporationFundlist')
const viewHNMDK = () => import('@/modules/HNcorporationfund/operators/viewHNMDKApplyOperator')
const editHNCPLQ = () => import('@/modules/HNcorporationfund/operators/ViewCorporationFundOperator')
const editHNCPSH = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPSHOperator')
const editHNCPDB = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPDBOperator')
const editHNCPFH = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPFHOperator')
const editHNCPSX = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPSXOperator')
const editHNCPSQFK = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPSQFKOperator')
const editHNCPFK = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPFKOperator')
const editHNCPHK = () => import('@/modules/HNcorporationfund/operators/ViewEditHNCPHKOperator')
const hnproductfundview = () => import('@/modules/HNcorporationfund/operators/ViewHNDFinalOperator')

const editLQ = () => import('@/modules/corporationfund/operators/LQApplicationCorporationFund')
const editDKSH = () => import('@/modules/corporationfund/operators/DKApplicationCorporationFund')
const editDKFH = () => import('@/modules/corporationfund/operators/DKFHApplicationCorporationFund')
const editWDSX = () => import('@/modules/corporationfund/operators/WDSXApplicationCorporationFund')
const editSQFD = () => import('@/modules/corporationfund/operators/SQFDApplicationCorporationFund')
const editWDFK = () => import('@/modules/corporationfund/operators/WDFKApplicationCorporationFund')
const editWDHK = () => import('@/modules/corporationfund/operators/WDHKApplicationCorporationFund')
const editDBJG = () => import('@/modules/corporationfund/operators/DBJGApplicationCorporationFund')
const productfundview = () => import('@/modules/corporationfund/ViewGuaranteeCorporationFund')
const hncorporationfundview = () => import('@/modules/HNcorporationfund/operators/viewHNMDKApplyOperator')
const PoliticalFund = () => import('@/modules/politicalFund/PoliticalFundlist')
const editZCDLQ = () => import('@/modules/politicalfund/operators/LQApplicationPoliticalFund')
const editZCDSH = () => import('@/modules/politicalfund/operators/DKApplicationPoliticalFund')
const editZCDSX = () => import('@/modules/politicalfund/operators/WDSXApplicationPoliticalFund')
const editZCDFD = () => import('@/modules/politicalfund/operators/SQFDApplicationPoliticalFund')
const editZCDWDFH = () => import('@/modules/politicalfund/operators/WDFKApplicationPoliticalFund')
const editZCDHK = () => import('@/modules/politicalfund/operators/WDHKApplicationPoliticalFund')
const politicalfundview = () => import('@/modules/politicalfund/operators/ViewGuaranteePoliticalFund')
const PageMyWorks = () => import('@/modules/corporationfund/PageMyWorks')
const PageBankPick = () => import('@/modules/corporationfund/PageBankPick')
const uploadXwdIntentFile = () => import('@/modules/corporationfund/uploadintentfile/uploadXwdIntentFile')
const cxdDbjgFh = () => import('@/modules/cxsd/cxd/cxdDbjgFh')
const cxdViewInfo = () => import('@/modules/cxsd/cxd/cxdViewInfo')
const sphcpHkList = () => import('@/modules/corporationfund/sphcpHkList')

export default [
  {
    path: '/corporationfund',
    name: 'corporationfund',
    component: CorporationFund,
    meta: {
      title: '信保产品申请',
      isBlack: true
    },
  },

  {
    path: '/HNcorporationfund',
    name: 'HNcorporationfund',
    component: HNCorporationFund,
    meta: {
      title: '惠农贷申请',
      isBlack: true
    },
  },

  {
    path: '/viewHNMDK',
    name: 'viewHNMDK',
    component: viewHNMDK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPLQ',
    name: 'editHNCPLQ',
    component: editHNCPLQ,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPSH',
    name: 'editHNCPSH',
    component: editHNCPSH,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPDB',
    name: 'editHNCPDB',
    component: editHNCPDB,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPFH',
    name: 'editHNCPFH',
    component: editHNCPFH,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPSX',
    name: 'editHNCPSX',
    component: editHNCPSX,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPSQFK',
    name: 'editHNCPSQFK',
    component: editHNCPSQFK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPFK',
    name: 'editHNCPFK',
    component: editHNCPFK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editHNCPHK',
    name: 'editHNCPHK',
    component: editHNCPHK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/hnproductfundview',
    name: 'hnproductfundview',
    component: hnproductfundview,
    meta: {
      title: '',
      fullscreen: true,
    },
  },

  {
    path: '/editLQ',
    name: 'editLQ',
    component: editLQ,
    meta: {
      title: '',
      fullscreen: true,
    },
  },

  {
    path: '/editDKSH',
    name: 'editDKSH',
    component: editDKSH,
    meta: {
      title: '',
      fullscreen: true,
    },
  },

  {
    path: '/editDKFH',
    name: 'editDKFH',
    component: editDKFH,
    meta: {
      title: '',
      fullscreen: true,
    },
  },

  {
    path: '/editWDSX',
    name: 'editWDSX',
    component: editWDSX,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editSQFD',
    name: 'editSQFD',
    component: editSQFD,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editWDFK',
    name: 'editWDFK',
    component: editWDFK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editWDHK',
    name: 'editWDHK',
    component: editWDHK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/productfundview',
    name: 'productfundview',
    component: productfundview,
    meta: {
      title: '',
      fullscreen: true,

    },
  },
  {
    path: '/editDBJG',
    name: 'editDBJG',
    component: editDBJG,
    meta: {
      title: '',
      fullscreen: true,
    },
  },

  {
    path: '/hncorporationfundview',
    name: 'hncorporationfundview',
    component: hncorporationfundview,
    meta: {
      title: '',
      fullscreen: true,
    },
  },

  {
    path: '/PoliticalFund',
    name: 'PoliticalFund',
    component: PoliticalFund,
    meta: {
      title: '政采贷申请',
      // fullscreen: true,
    },
  },
  {
    path: '/editZCDLQ',
    name: 'editZCDLQ',
    component: editZCDLQ,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editZCDSH',
    name: 'editZCDSH',
    component: editZCDSH,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editZCDSX',
    name: 'editZCDSX',
    component: editZCDSX,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editZCDFD',
    name: 'editZCDFD',
    component: editZCDFD,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editZCDWDFH',
    name: 'editZCDWDFH',
    component: editZCDWDFH,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/editZCDHK',
    name: 'editZCDHK',
    component: editZCDHK,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {
    path: '/politicalfundview',
    name: 'politicalfundview',
    component: politicalfundview,
    meta: {
      title: '',
      fullscreen: true,
    },
  },
  {

    path: '/myworks',
    name: 'myworks',
    component: PageMyWorks,
    meta: {
      title: '我的已办',
    },
  },
  {
    path: '/bankpick',
    name: 'bankpick',
    component: PageBankPick,
    meta: {
      title: '银行领取',
    },
  },
  {
    path: '/upload_xwd_intentfile',
    name: 'upload_xwd_intentfile',
    component: uploadXwdIntentFile,
    meta: {
      title: '上传意向函',
    },
  },
  {
    path: '/cxd_dbjg_fh',
    name: 'cxd_dbjg_fh',
    component: cxdDbjgFh,
    meta: {
      title: '创新贷复核',
    },
  },
  {
    path: '/cxd_view_info',
    name: 'cxd_view_info',
    component: cxdViewInfo,
    meta: {
      title: '创新贷放款数据查询',
      isBlack: true
    },
  },
  {
    path: '/sphcpHkList',
    name: 'sphcpHkList',
    component: sphcpHkList,
    meta: {
      title: '省普惠产品还款',
    },
  },
]
